import { isDev, User } from '@/shared';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const useUserModel = defineStore('user-model', () => {
  const user = ref<User | null>(null);

  const MASTER_ACCOUNT_GROUP_ID = isDev() ? 47 : 58;

  const hasMasterAccount = computed(() => user.value?.groups_ids?.includes(MASTER_ACCOUNT_GROUP_ID));

  return {
    user,
    hasMasterAccount,
    hasAgentAccount: computed(() => !hasMasterAccount.value)
  };
});
